import { ErrorMessage as Error } from './styled';
import PropTypes from 'prop-types';
import React from 'react';

const ErrorMessage = ({
    align,
    error,
    margin,
    marginBottom,
    marginLeft = 20,
    marginTop = 0,
    relative
}) => {
    if (!!error && typeof error === 'string') {
        const errorProps = {
            align,
            margin,
            marginBottom,
            marginLeft,
            marginTop,
            relative
        };
        return (
            <Error { ...errorProps }>
                { error }
            </Error>
        );
    } else {
        return null;
    }
};

ErrorMessage.propTypes = {
    align: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    margin: PropTypes.string,
    marginBottom: PropTypes.number,
    marginLeft: PropTypes.number,
    marginTop: PropTypes.number,
    relative: PropTypes.bool
};

export default ErrorMessage;
